import React from "react";
import { Box, Typography } from "@mui/material";

import halfCircles from "../../assets/half-circles.png";

const Banner = ({ title, description, image }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "350px",
        background: "linear-gradient(0deg, #2A2177 0%, #0624BE 100%)",
        display: "flex",
        alignItems: "center",
        pl: "84px",
        pr: "219px",
        py: "74px",
        overflow: "hidden",
        position: "relative",
        "@media (max-width: 1200px)": {
          px: "24px",
          py: "78px",
        },
        "@media (max-width: 780px)": {
          flexDirection: "column",
          textAlign: "center",
          px: "16px",
          pt: "48px",
          pb: 2,
          height: "420px",
        },
      }}
    >
      {/* Left Text Content */}
      <Box
        sx={{
          flex: 2,
          zIndex: 1,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "2.5rem",
            fontWeight: 700,
            color: "#ffffff",
            lineHeight: 1.3,
            mb: 2,
            "@media (max-width: 1200px)": {
              fontSize: "1.75rem",
              fontWeight: "semiBold",
            },
            "@media (max-width: 780px)": {
              fontSize: "1.5rem",
              mb: 1,
            },
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "regular",
            color: "#ffffff",
            lineHeight: 1.7,
            maxWidth: "624px",
            "@media (max-width: 1200px)": {
              fontSize: "18px",
            },
            "@media (max-width: 780px)": {
              fontSize: "16px",
            },
          }}
        >
          {description}
        </Typography>
      </Box>

      {/* Right Infographic Image */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          position: "relative",
        }}
      >
        {/* Background Half Circles */}
        <Box
          component="img"
          src={halfCircles}
          aria-hidden="true"
          sx={{
            position: "absolute",
            width: "599px",
            height: "350px",
            objectFit: "contain",
            left: -100,
            "@media (max-width: 1200px)": {
              left: 0,
            },
            "@media (max-width: 780px)": {
              left: "50%",
              transform: "translateX(-50%)",
              width: "370px",
              height: "auto",
            },
            zIndex: 0,
          }}
        />
        {/* Foreground about-bg */}
        <Box
          component="img"
          src={image}
          sx={{
            position: "relative",
            zIndex: 1,
            width: "383px",
            height: "320px",
            "@media (max-width: 1200px)": {
              width: "386px",
              height: "322px",
            },
            "@media (max-width: 780px)": {
              fontSize: "18px",
              width: "188px",
              height: "157px",
            },
          }}
        />
      </Box>
    </Box>
  );
};
export default Banner;
